import cx from 'classix';
import { ReactNode } from 'react';

const HighlightedIconCircle = ({
  color,
  children,
}: {
  color: 'blue' | 'green' | 'yellow';
  children: ReactNode;
}) => {
  return (
    <div
      className={cx(
        'shrink-0 size-12 relative rounded-3xl outline-8 -outline-offset-4',
        color === 'blue' && 'bg-secondary-brand-50 outline-secondary-brand-25',
        color === 'green' && 'bg-success-100 outline-success-25',
        color === 'yellow' && 'bg-accent-500 outline-warning-100',
      )}
    >
      <div className='size-6 left-3 top-3 absolute overflow-hidden'>
        <div
          className={cx(
            'contents size-5 left-0.5 top-[3px] absolute',
            color === 'blue' && 'text-brand-500',
            color === 'green' && 'text-success-500',
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default HighlightedIconCircle;
